// Global fetch interceptor for authentication.
//
// Attaches `Authorization: Bearer <token>` (from localStorage) to every request
// going to the Clarytix backend, and redirects to the login page on a 401. This
// wraps window.fetch once so all existing fetch() call sites are covered without
// editing each one. Imported for its side effect in index.js.

const BACKEND_HOSTS = ['clarytix-backend.onrender.com', 'localhost:5000'];

const originalFetch = window.fetch.bind(window);

function urlOf(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
}

function isBackend(input) {
    const url = urlOf(input);
    return BACKEND_HOSTS.some((h) => url.includes(h));
}

window.fetch = async (input, init = {}) => {
    if (isBackend(input)) {
        const token = localStorage.getItem('token');
        if (token) {
            const headers = new Headers(init.headers || {});
            if (!headers.has('Authorization')) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            init = { ...init, headers };
        }
    }

    const response = await originalFetch(input, init);

    // Token missing/expired/invalid → send the user back to login.
    if (response.status === 401 && isBackend(input)) {
        localStorage.clear();
        if (window.location.pathname !== '/') {
            window.location.assign('/');
        }
    }

    return response;
};
